@if (lines && lines.length > 1) {
  @for (line of lines; track line) {
    {{ line | translate }}
    @if (!isEmployeeDrinking(line)) {
      |&nbsp;
    }
  }
} @else {
  <p>{{ text | translate }}</p>
}
